<script setup>
import { computed } from 'vue'
import { ProfilePicture } from '@components'

import { useAppointments } from '@store/appointments.js'
const $appointments = useAppointments()

import { useSettings } from '@store/settings'
const $settings = useSettings()

import { useCustomizer } from '@store/customizer.js'
const $customizer = useCustomizer()

const emit = defineEmits(['select'])

const props = defineProps({
    staff: {
        type: Object
    }
})

const selectStaff = (event) => {
    if (event.target.classList.contains('staff-details-link')) return

    emit('select', props.staff)
}

const staffImageClass = computed(() => {
    return `staff-image ${$customizer.isRounded ? '' : '!rounded-none'} ${$settings.customizer.staff.layout_type == 'grid01' ? '!h-[162px]' : '!h-[128px]'}`
})

const visitDetails = (staffId) => {
    $appointments.activeStep = 'staff-profile'
    sessionStorage.setItem('activeStaffId', staffId)
}
</script>

<style lang="scss" scoped></style>

<template>
    <div @click.prevent="selectStaff($event)" 
         class="staff-item" 
         :class="{
             'staff-item--no-image': !$settings.customizer.staff.show_image,
             'staff-item--no-rounded': !$customizer.isRounded
         }"
         :title="staff.name">
        <div v-if="$settings.customizer.staff.show_image" 
             class="staff-image-group"
             :class="{
                 'active': $appointments.selectedStaff.staff_id === props.staff.staff_id,
                 'staff-image-group--no-rounded': !$customizer.isRounded
             }">
            <ProfilePicture 
                :name="props.staff.name" 
                :img="props.staff.profile_image_url" 
                :bgColor="props.staff.color" 
                :textClass="staffImageClass" 
                :imgClass="staffImageClass" />

            <div 
                v-if="$settings.customizer.staff.show_details" 
                @click="visitDetails(props.staff.staff_id)" 
                class="staff-details-link cursor-pointer" 
                :style="`color: ${$settings.customizer.design.brand_color} !important`">
                Details
            </div>
        </div>

        <div class="staff-name" :style="$customizer.subtitleStyle">
            {{ staff.name }}
        </div>
    </div>
</template>
